/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import moment from "moment";
import { DATE_TIME_FORMAT, TIME_FORMAT, TIME_FORMAT_WITH_SECONDS, } from "../../utils/constant";
import { getStartOfTheDayTime } from "../../utils/methods";
export function timeManipulation(value) {
    if (value == null || undefined || "") {
        return "";
    }
    const splitString = value.split("(");
    if (splitString.length < 2) {
        return "";
    }
    const timeString = splitString[1].split("+")[0];
    const c = Number(timeString);
    // let timeNumber;
    // const currentTime = new Date().getTime();
    // if (currentTime - c < 60000) {
    //   timeNumber = currentTime - c;
    //   return Math.floor(Number(timeNumber / 1000)) + " Sec Ago";
    // } else
    if (getStartOfTheDayTime() > c) {
        return moment(c).format(DATE_TIME_FORMAT);
    }
    else {
        return moment(c).format(TIME_FORMAT_WITH_SECONDS);
    }
}
export function timeManipulationForOrderBook(value) {
    if (value == null || undefined || "") {
        return "";
    }
    const splitString = value.split("(");
    if (splitString.length < 2) {
        return "";
    }
    const timeString = splitString[1].split("+")[0];
    const c = Number(timeString);
    return moment(c).format(TIME_FORMAT);
}
// export function triggerTimeForSL(value: string) {
//   var a = value;
//   a = a.substring(6, 19);
//   var c = Number(a);
//   var d = new Date(c);
//   const e = d.toString();
//   const f = e.substring(16, 24);
//   var time = f.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
//     f,
//   ];
//   var timeNumber;
//   if (time.length > 1) {
//     time = time.slice(1);
//     time[5] = +time[0] < 12 ? "AM" : "PM";
//     timeNumber = Number(time[0]);
//     timeNumber = +timeNumber % 12 || 12;
//   }
//   if ((timeNumber?.toString().length || 0) == 1) {
//     timeNumber = "0" + timeNumber?.toString();
//   }
//   return timeNumber + time[1] + time[2] + " " + time[5];
// }
export function triggerDate(value) {
    var a = value;
    a = a.substring(6, 19);
    var c = Number(a);
    var d = new Date(c);
    const e = d.toString();
    var date = e.substring(8, 10);
    var month = e.substring(4, 7).toUpperCase();
    var year = e.substring(11, 15);
    var finalValue = date + " " + month + " " + year + ", ";
    return finalValue;
}
export function triggerDateAnalyise(value) {
    var a = value;
    a = a.substring(6, 19);
    var c = Number(a);
    var d = new Date(c);
    const e = d.toString();
    var date = e.substring(8, 10);
    var month = d.getMonth() + 1;
    var year = e.substring(11, 15);
    var finalValue = year + "-" + date + "-" + month;
    return finalValue;
}
export function gettingCompanyWithCE(value) {
    var splittingString = value.split(" ");
    return splittingString;
}
